export default "__VITE_ASSET__CCFc9TIU__"